import api, { setTokens, clearTokens } from './api';

export const register = async (payload) => {
  const response = await api.post('/auth/register', payload);
  if (response.data?.accessToken && response.data?.refreshToken) {
    setTokens(response.data.accessToken, response.data.refreshToken);
  }
  return response.data;
};

export const login = async (payload) => {
  const response = await api.post('/auth/login', payload);
  if (response.data?.accessToken && response.data?.refreshToken) {
    setTokens(response.data.accessToken, response.data.refreshToken);
  }
  return response.data;
};

export const logout = async (refreshToken) => {
  await api.post('/auth/logout', { refreshToken });
  clearTokens();
};

export const getMe = async () => {
  const response = await api.get('/me');
  return response.data;
};

export const heartbeat = async (payload) => {
  const response = await api.post('/me/heartbeat', payload);
  return response.data;
};

export const getFlags = async (params) => {
  const response = await api.get('/flags', { params });
  return response.data;
};

export const getLatestRelease = async (params) => {
  const response = await api.get('/releases/latest', { params });
  return response.data;
};

export const submitFeedback = async (payload) => {
  const response = await api.post('/feedback', payload);
  return response.data;
};
